import { getAvatarDims } from '@op/app-shared'
import cls from 'classnames'
import { type CSSProperties, type ReactNode } from 'react'

type AvatarWrapperProps = {
	readonly border?: boolean
	readonly children: ReactNode
	readonly className?: string
	readonly disableWrapper?: boolean
	readonly padding?: boolean
	readonly radius?: boolean
	readonly size: number
}

export const AvatarWrapper = ({
	border = true,
	children,
	className,
	disableWrapper = false,
	padding = true,
	radius = true,
	size,
}: AvatarWrapperProps) => {
	if (disableWrapper) {
		border = padding = radius = false
	}

	const [innerStyle, outerStyle] = (() => {
		const [borderWidth, boxPadding, innerRadius, innerSize, outerRadius] = getAvatarDims(
			size,
			disableWrapper,
			padding,
			radius,
		)

		const innerStyle = {
			borderRadius: innerRadius,
			height: innerSize,
			width: innerSize,
		} satisfies CSSProperties

		const outerStyle = {
			borderRadius: outerRadius,
			borderWidth,
			height: size,
			padding: boxPadding,
			width: size,
		} satisfies CSSProperties

		return [innerStyle, outerStyle]
	})()

	// We hide the border with transparency so the contents don't change size
	return (
		<div
			className={cls('border-solid z-1', border ? 'border-teal' : 'border-transparent', className)}
			style={outerStyle}
		>
			<div className="flex-center overflow-hidden" style={innerStyle}>
				{children}
			</div>
		</div>
	)
}
